const reportWebVitals = (): void => {};

export default reportWebVitals;
